import { getTeamStatusClass } from "./statusHelpers";
import "./TeamCard.sass";

/**
 * Componente TeamCard - Renderiza la información de un equipo
 * 
 * @param {string} name - Nombre completo del equipo
 * @param {string} shortName - Nombre corto del equipo (máx 3 caracteres)
 * @param {string} image - URL del logo del equipo
 * @param {string} statusClass - Clase de estado del equipo (winner, loser, draw)
 * @param {string} position - Posición del equipo: 'left' o 'right'
 */
export default function TeamCard({ name, shortName, image, statusClass, position = "left" }) {
  return (
    <div className={`team team-${position} ${getTeamStatusClass(statusClass)}`}>
      <div className="team-info">
        <img src={image} alt={name}></img>
        <span className="team-full-name">{shortName}</span>
      </div>
    </div>
  );
}